import React from 'react';
import { Locale } from '@types';

export type Slugs = {
  [key in Locale]: string;
};

export const SlugContext = React.createContext({} as Slugs);
